










































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import report from '@/components/data/report.vue';
import { searchByName } from '@/api/common';
import moment from 'moment';
import { legalStartScaleColumns, dealTypeList } from '@/utils/report';
import { getCommonList } from '@/api/common';

const url = '/dataService/reportForm/startCaliber/queryList';
const downloadUrl = '/dataService/reportForm/startCaliber/download';

@Component({
  components: { report }
})
class USDIRREPORT extends Vue {
  projectName: string = '';
  currency: number = 0;
  url: string = url;
  endDate: string = '';
  startDate: string = '';
  downloadUrl: string = downloadUrl;
  fileName: string = '';
  columns: any[] = legalStartScaleColumns;
  industry: string = '';
  projectNameTmp: string = '';
  currencyList: any[] = [
    {
      name: '全部币种',
      value: 0
    },
    {
      name: '人民币',
      value: 1
    },
    {
      name: '美元',
      value: 2
    },
    {
      name: '人民币及美元',
      value: 3
    }
  ];
  dealTypeList: any[] = dealTypeList;
  dealType: number = 1;

  get requestData() {
    const { currency, projectName, startDate, endDate, dealType } = this;
    return {
      currency: currency === 0 ? null : currency,
      projectName,
      startDate,
      endDate,
      dealType
    };
  }

  mounted() {
    let date = moment(new Date()).format('YYYYMMDD');
    this.fileName = `百川启动口径数据报表_${date}`;
  }

  handleSearch(val) {
    this.projectName = val;
  }

  onChange(date, dateString) {
    this.endDate = date ? moment(date).format('YYYYMMDD') : '';
    if (this.projectNameTmp !== this.projectName) {
      this.projectName = this.projectNameTmp;
    }
  }

  startOnChange(date, dateString) {
    this.startDate = date ? moment(date).format('YYYYMMDD') : '';
    if (this.projectNameTmp !== this.projectName) {
      this.projectName = this.projectNameTmp;
    }
  }

  currencyChange() {
    if (this.projectNameTmp !== this.projectName) {
      this.projectName = this.projectNameTmp;
    }
  }

  dealTypeChange() {
    if (this.projectNameTmp !== this.projectName) {
      this.projectName = this.projectNameTmp;
    }
  }
}
export default USDIRREPORT;
